import { AccountService } from "@app/services/account-service";

export function appInitializer(accountService: AccountService) {
  return () => {
    return new Promise<void>((resolve) => {
      // Attempt to refresh token on app start up to auto authenticate
      accountService.refreshToken()
        .subscribe({
          next: () => {
            resolve();
          },
          error: (error) => {
            // Handle error appropriately, you may want to log it or perform other actions
            console.error('Error refreshing token:', error);
            resolve(); // Resolve the promise regardless to ensure the app initializes
          }
        });
    });
  };
}